var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLand = function SvgLand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#land_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0245A3",
    d: "M29.121 13.333H27.32q-.242.684-.564 1.334h1.232l1.083 6.666h-8.178l-.721.706 1.073 8.628H10.756l1.073-8.628-.721-.706H2.913l1.096-6.666h1.247a12 12 0 0 1-.561-1.334H2.879L0 30.832V32h32v-.94zM9.412 30.667H1.379l1.316-8h7.72zm13.176 0-1.003-8h7.702l1.298 8zM16 22.388l6.599-6.455a9.27 9.27 0 0 0 2.734-6.6 9.28 9.28 0 0 0-2.734-6.6A9.27 9.27 0 0 0 16 0c-2.493 0-4.836.97-6.6 2.733-3.639 3.639-3.639 9.56.005 13.204zM10.343 3.676A7.95 7.95 0 0 1 16 1.333c2.137 0 4.145.832 5.656 2.343A7.94 7.94 0 0 1 24 9.333a7.94 7.94 0 0 1-2.339 5.652L16 20.524l-5.657-5.533A7.95 7.95 0 0 1 8 9.333a7.95 7.95 0 0 1 2.343-5.657M16 13.306a3.99 3.99 0 0 0 3.987-3.986A3.99 3.99 0 0 0 16 5.333a3.99 3.99 0 0 0-3.987 3.987A3.99 3.99 0 0 0 16 13.307m0-6.64a2.656 2.656 0 0 1 2.653 2.654A2.657 2.657 0 0 1 16 11.973a2.657 2.657 0 0 1-2.653-2.653A2.657 2.657 0 0 1 16 6.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "land_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgLand;